// extracted by mini-css-extract-plugin
export var arrow = "CaseStudyBanner-module--arrow--78aa0";
export var banner = "CaseStudyBanner-module--banner--9dd42";
export var link = "CaseStudyBanner-module--link--90ff6";
export var logo = "CaseStudyBanner-module--logo--24a6c";